import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { CookieService } from 'ngx-cookie-service';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { LoginComponent } from './component/login/login.component';

import { HomepageComponent } from './component/homepage/homepage.component';
import { DocumentaryComponent } from './component/documentary/documentary.component';
import { HeaderComponent } from './component/header/header.component';
import { ActivityComponent } from './component/activity/activity.component';
import { OperatorComponent } from './component/operator/operator.component';
import { CustomerComponent } from './component/customer/customer.component';
import { TicketComponent } from './component/ticket/ticket.component';
import { ClienteComponent } from './popup/cliente/cliente.component';
import { NewCustomerComponent } from './popup/new-customer/new-customer.component';
import { NewfolderComponent } from './popup/newfolder/newfolder.component';
import { UploadfileComponent } from './popup/uploadfile/uploadfile.component';
import { NewTicketComponent } from './popup/new-ticket/new-ticket.component';
import { ToastContainer } from './toast/toast.component';
import { LoadingScreenComponent } from './component/loading-screen/loading-screen.component';
import { LoadingScreenInterceptor } from './services/loading-screen/loading.interceptor';
import { ContractComponent } from './component/contract/contract.component';
import { EliminaComponent } from './popup/elimina/elimina.component';
import { ListPipe } from './list.pipe';
import { AssocComponent } from './popup/assoc/assoc.component';
import { GroupComponent } from './component/group/group.component';
import { OpenticketComponent } from './popup/openticket/openticket.component';
import { WaitingticketComponent } from './popup/waitingticket/waitingticket.component';
import { FullcalendarComponent } from './component/fullcalendar/fullcalendar.component';
import { FullCalendarModule } from '@fullcalendar/angular';
import { AddeventComponent } from './popup/addevent/addevent.component';
import { ExceluploadComponent } from './popup/excelupload/excelupload.component'; 
import { ChangeNameFolderComponent } from './popup/change-name-folder/change-name-folder.component';
import { OpenfolderComponent } from './popup/openfolder/openfolder.component';
import { SavebpmnComponent } from './popup/savebpmn/savebpmn.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AcitivitypopupComponent } from './popup/acitivitypopup/acitivitypopup.component';
import { EasydocComponent } from './component/easydoc/easydoc.component';
import { StoreactivityComponent } from './popup/storeactivity/storeactivity.component';
import { StuckactivityComponent } from './popup/stuckactivity/stuckactivity.component';



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomepageComponent,
    DocumentaryComponent,
    HeaderComponent,
    ActivityComponent,
    OperatorComponent,
    CustomerComponent,
    ClienteComponent,
    NewCustomerComponent,
    NewfolderComponent,
    UploadfileComponent,
    TicketComponent,
    NewTicketComponent,
    ToastContainer,
    LoadingScreenComponent,
    ContractComponent,
    EliminaComponent,
    ListPipe,
    AssocComponent,
    GroupComponent,
    AddeventComponent,
    OpenticketComponent,
    WaitingticketComponent,
    FullcalendarComponent,
    ExceluploadComponent,
    ChangeNameFolderComponent,
    OpenfolderComponent,
    SavebpmnComponent,
    AcitivitypopupComponent,
    EasydocComponent,
    StoreactivityComponent,
    StuckactivityComponent,
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    NgbModule,
    FontAwesomeModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    FullCalendarModule,
    BsDatepickerModule.forRoot(),
    BrowserAnimationsModule
  ],
  providers: [
    CookieService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingScreenInterceptor,
      multi: true
    }
  ],
  bootstrap: [
    AppComponent,
    ToastContainer
  ],
  entryComponents: [
    ClienteComponent,
    NewCustomerComponent,
    NewfolderComponent,
    UploadfileComponent,
    NewTicketComponent,
    EliminaComponent,
    AssocComponent,
    AddeventComponent,
    OpenticketComponent,
    WaitingticketComponent,
    ExceluploadComponent,
    ChangeNameFolderComponent,
    OpenfolderComponent,
    SavebpmnComponent,
    AcitivitypopupComponent,
    StoreactivityComponent,
    StuckactivityComponent
  ],
  exports: [ClienteComponent]
})

export class AppModule { }